<template>
  <button
    :class="['toolbar-btn', { active }]"
    :title="title"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ToolbarButton',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.toolbar-btn {
  background: white;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 4px 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  color: #374151;
}

.toolbar-btn:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: #d1d5db;
  color: gray;
  fill: gray;
}

.toolbar-btn.active {
  background: #3b82f6;
  color: white;
  fill: white;
  border-color: #3b82f6;
}

.toolbar-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>